import { render } from "./CamposCustomEditor.vue?vue&type=template&id=ee0135e2&scoped=true"
import script from "./CamposCustomEditor.vue?vue&type=script&lang=js"
export * from "./CamposCustomEditor.vue?vue&type=script&lang=js"

import "./CamposCustomEditor.vue?vue&type=style&index=0&id=ee0135e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0135e2"]])

export default __exports__